import I18n from 'I18n';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import ChangePlaylistThumbnailButton from './ChangePlaylistThumbnailButton';
import PlaylistItemsSearch from './PlaylistItemsSearch';
import { LikeLink } from '../../../components/AcademyLinks';
import styled from 'academy-common-lib/utils/Styling';
import { CardMenuOptions } from '../../cardMenu/components/CardMenu';
import { jsx as _jsx } from "react/jsx-runtime";
const PLAYLIST_ITEMS_HEIGHT = 250;
export const UndoLink = styled(LikeLink).withConfig({
  displayName: "ChangePlaylistThumbnail__UndoLink",
  componentId: "f1cbvq-0"
})(["flex:1;text-align:right;"]);
const ChangeThumbnailItemsList = ({
  playlist: {
    id: playlistId
  },
  items,
  renderList = content => /*#__PURE__*/_jsx(UIScrollContainer, {
    maxHeight: PLAYLIST_ITEMS_HEIGHT,
    children: /*#__PURE__*/_jsx(CardMenuOptions, {
      "aria-label": I18n.text('learningCenter.cardMenu.playlistItems'),
      children: content
    })
  }),
  renderRow = (content, key) => /*#__PURE__*/_jsx(UISideNavItem, {
    title: content
  }, key),
  onItemClick
}) => {
  return renderList(items && items.map(item => {
    const {
      itemId
    } = item;
    return renderRow( /*#__PURE__*/_jsx(ChangePlaylistThumbnailButton, {
      item: item,
      onClick: () => {
        if (onItemClick) onItemClick(item);
      },
      playlistId: playlistId,
      style: {
        width: '100%',
        height: 24
      }
    }), `playlist_${playlistId}_item_${itemId}`);
  }));
};
const ChangePlaylistThumbnail = ({
  playlistId,
  renderList,
  renderRow,
  onItemClick
}) => {
  return /*#__PURE__*/_jsx(PlaylistItemsSearch, {
    playlistId: playlistId,
    render: (playlist, items) => playlist && items && /*#__PURE__*/_jsx(ChangeThumbnailItemsList, {
      items: items,
      onItemClick: onItemClick,
      playlist: playlist,
      renderList: renderList,
      renderRow: renderRow
    })
  });
};
export default ChangePlaylistThumbnail;